import { render, staticRenderFns } from "./detailedTwo.vue?vue&type=template&id=58cfa2d0&scoped=true&"
import script from "./detailedTwo.vue?vue&type=script&lang=js&"
export * from "./detailedTwo.vue?vue&type=script&lang=js&"
import style0 from "./detailedTwo.vue?vue&type=style&index=0&id=58cfa2d0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cfa2d0",
  null
  
)

export default component.exports